import React from 'react';
import { TrendUp, TrendDown, Minus } from '@phosphor-icons/react';
import { benchmarkComparison, NATIONAL_BENCHMARK } from '../lib/pendelLogic';

export default function BenchmarkPanel({ results }) {
  const cmp = benchmarkComparison(results);

  const rows = [
    {
      label: 'Pendelstrecke',
      pct: cmp.distance_pct,
      user: `${results.distance_km.toFixed(0)} km`,
      avg: `${NATIONAL_BENCHMARK.avg_distance_km.toFixed(0)} km`,
      higher_is_worse: true,
    },
    {
      label: 'Fahrzeit (einfach)',
      pct: cmp.time_pct,
      user: `${Math.round(results.minutes_one_way)} min`,
      avg: `${Math.round(NATIONAL_BENCHMARK.avg_minutes_one_way)} min`,
      higher_is_worse: true,
    },
    {
      label: 'Kosten pro Jahr',
      pct: cmp.cost_pct,
      user: `${Math.round(results.annual_cost)} €`,
      avg: `${Math.round(NATIONAL_BENCHMARK.avg_annual_cost_eur)} €`,
      higher_is_worse: true,
    },
    {
      label: 'Lebenszeit pro Jahr',
      pct: cmp.hours_pct,
      user: `${Math.round(results.annual_hours)} h`,
      avg: `${Math.round(NATIONAL_BENCHMARK.avg_annual_hours)} h`,
      higher_is_worse: true,
    },
  ];

  // Build emotional headline
  const worst = rows.reduce((a, b) => (Math.abs(b.pct) > Math.abs(a.pct) ? b : a));
  let headline;
  if (worst.pct > 30) {
    headline = `Du bist ${worst.pct}% über dem deutschen Durchschnitt bei ${worst.label.toLowerCase()}.`;
  } else if (worst.pct < -20) {
    headline = `Du bist ${Math.abs(worst.pct)}% besser als der deutsche Durchschnitts-Pendler bei ${worst.label.toLowerCase()}.`;
  } else {
    headline = `Du liegst nah am deutschen Durchschnitt — typischer Pendler.`;
  }

  return (
    <div className="mt-12" data-testid="benchmark-panel">
      <div className="flex items-end justify-between">
        <h2 className="font-display text-3xl md:text-4xl tracking-tighter">Du vs. Durchschnitt Deutschland</h2>
        <div className="hidden md:block h-px flex-1 bg-neutral-200 mx-6 mb-2" />
      </div>
      <p className="text-neutral-700 mt-3 max-w-2xl" data-testid="benchmark-headline">{headline}</p>

      <div className="mt-6 grid-border">
        <div className="grid grid-cols-12 px-5 py-3 border-b border-neutral-200 text-xs uppercase tracking-widest text-neutral-500">
          <div className="col-span-5">Kennzahl</div>
          <div className="col-span-3 text-right">Du</div>
          <div className="col-span-2 text-right">Ø DE</div>
          <div className="col-span-2 text-right">Differenz</div>
        </div>
        {rows.map((r, i) => {
          const worse = r.higher_is_worse ? r.pct > 5 : r.pct < -5;
          const better = r.higher_is_worse ? r.pct < -5 : r.pct > 5;
          const color = worse ? 'text-[#E63946]' : better ? 'text-[#2A9D8F]' : 'text-neutral-600';
          const Icon = worse ? TrendUp : better ? TrendDown : Minus;
          return (
            <div
              key={r.label}
              className="grid grid-cols-12 px-5 py-4 border-b border-neutral-200 last:border-b-0 items-center"
              data-testid={`benchmark-row-${i}`}
            >
              <div className="col-span-5 font-display text-lg">{r.label}</div>
              <div className="col-span-3 text-right font-mono">{r.user}</div>
              <div className="col-span-2 text-right font-mono text-neutral-500">{r.avg}</div>
              <div className={`col-span-2 text-right font-mono inline-flex items-center justify-end gap-1 ${color}`}>
                <Icon size={14} weight="bold" />
                {r.pct >= 0 ? '+' : ''}{r.pct}%
              </div>
            </div>
          );
        })}
      </div>
      <p className="text-xs text-neutral-500 mt-3">
        Quelle: Statistisches Bundesamt (Mikrozensus Pendlermobilität) & ADAC Mobilitätsstudien (Stand 2023/2024).
      </p>
    </div>
  );
}
